import axios from '@/services/api'

/**
 * @param {Object} query
 *
 * @returns {Promise<Object>}
 */
export const fetchEvents = (query = '') => {
	const url = `/api/events${query}&fields=eventsList&expand=eventsList`
	return axios.get(url)
}

/**
 * @param {String} query
 *
 * @returns {Promise<Object>}
 */
export const getActionFiles = (query) => {
	const url = `/api/event-action-files${query}`
	return axios.get(url)
}

/**
 * @param {String} query
 *
 * @returns {Promise<Object>}
 */
export const getActionLinks = (query) => {
	const url = `/api/event-action-links${query}`
	return axios.get(url)
}

/**
 *
 * @returns {Promise<Object>}
 */
export const fetchEventCategories = (query) => {
	const url = `/api/event-categories`
	return axios.get(url, { params: query })
}

/**
 * @param {Object} query
 *
 * @returns {Promise<Object>}
 */
export const fetchPartners = (query = '') => {
	const url = `/api/partners${query}&expand=partnersList&fields=partnersList`
	return axios.get(url)
}

/**
 * @param {number} eventId
 * @param {object} query
 *
 * @returns {Promise<Object>}
 */
export const getEvent = (eventId, query = {}) => {
	const url = `/api/events/${eventId}?fields=eventView&expand=eventView`
	return axios.get(url, { params: query })
}

/**
 * @param {object} query
 *
 * @returns {Promise<Object>}
 */
export const getAgendaEvent = (query = {}) => {
	const url = `/api/event-agenda${query}&fields=sessionsList&expand=sessionsList`
	return axios.get(url)
}

/**
 * @param {object} query
 *
 * @returns {Promise<Object>}
 */

export const getSubSessions = (query = {}) => {
	const url = `/api/event-agenda${query}&fields=sessionsList&expand=sessionsList`
	return axios.get(url)
}

/**
 * @param {object} data
 *
 * @returns {Promise<Object>}
 */
export const followEvent = (data = {}) => {
	const url = `/api/event-users`
	return axios.post(url, data)
}

/**
 * @param {number} eventId
 *
 * @returns {Promise<Object>}
 */
export const unfollowEvent = (eventId) => {
	const url = `/api/event-users/${eventId}`
	return axios.delete(url)
}

/**
 * @param {Object} query
 *
 * @returns {Promise<Object>}
 */
export const getAttendeesEvent = (query) => {
	const url = `/api/users${query}`
	return axios.get(url)
}

/**
 *
 * @returns {Promise<Object>}
 */
export const getEventSession = (id) => {
	const url = `/api/event-agenda/${id}?fields=sessionView&expand=sessionView`
	return axios.get(url)
}

/**
 *
 * @returns {Promise<Object>}
 */
export const getAttendeeEvent = (id) => {
	const url = `/api/users/${id}?expand=qr,public,follow_note,follow_status,private`
	return axios.get(url)
}

/**
 * @param {object} data
 *
 * @returns {Promise<Object>}
 */
export const addToSchedule = (data = {}) => {
	const url = `/api/event-users-schedule`
	return axios.post(url, data)
}

/**
 * @param {number} eventId
 *
 * @returns {Promise<Object>}
 */
export const removeFromSchedule = (eventId) => {
	const url = `/api/event-users-schedule/${eventId}`
	return axios.delete(url, { Headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const addSessionAgendaQuestion = (data = {}) => {
	const url = '/api/question-answers'
	return axios.post(url, data)
}

/**
 * @param {String} query
 *
 * @returns {Promise<Object>}
 */
export const getSessionQuestions = (query) => {
	const url = `/api/question-answers${query}&expand=questionList&fields=questionList`
	return axios.get(url)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const upvoteSessionQuestion = (data) => {
	const url = '/api//question-answers/add-upvote'
	return axios.post(url, data)
}

/**
 * @param {number} id
 *
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const deleteUpvoteSessionQuestion = (id) => {
	const url = `/api/question-answers/remove-upvote?id=${id}`
	return axios.delete(url)
}

/**
 * @param {Object} payload
 *
 * @returns {Promise<Object>}
 */

export const getEventTracks = ({ eventId, page }) => {
	const url = `/api/event-tracks?event_id=${eventId}&page=${page}`
	return axios.get(url)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const addMyAgenda = (data) => {
	const url = `/api/agenda-users-schedule`
	return axios.post(url, data)
}

/**
 * @param {Number} id
 *
 * @returns {Promise<Object>}
 */
export const removeMyAgenda = (id) => {
	const url = `/api/agenda-users-schedule/${id}`
	return axios.delete(url)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const voteEventPoll = (data) => {
	const url = `/api/polls-history`
	return axios.post(url, data)
}

/**
 * @param {String} query
 *
 * @returns {Promise<Object>}
 */

export const getEventSpeakersById = (query) => {
	const url = `/api/speakers${query}&expand=speakerView&fields=speakerView`
	return axios.get(url)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const voteEventRating = (data) => {
	const url = '/api/event-rating'
	return axios.post(url, data)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const voteSessionRating = (data) => {
	const url = '/api/session-rating'
	return axios.post(url, data)
}

/**
 * @param {Number} id
 *
 * @returns {Promise<Object>}
 */
export const getExhibitorById = (id, groupId) => {
	const url = `/api/partners/${id}?expand=partnerView&fields=partnerView&group_id=${groupId}`
	return axios.get(url)
}
/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */

export const putExhibitorPartnersFollow = (data) => {
	const url = `/api/users-bookmarks/update`
	return axios.put(url, data)
}
/**
 * @param {Number} id
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */

export const deleteExhibitorPartnersFollow = (id, data) => {
	const url = `/api/users-bookmarks/${id}`
	return axios.delete(url, { data })
}
/**
 * @param {String} query
 *
 * @returns {Promise<Object>}
 */
export const getBoothStaffList = (query) => {
	const url = `/api/users?filter=exhibitors&${query}`
	return axios.get(url)
}
/**
 * @param {Object} sessionRegister
 * @returns {Promise<Object>}
 */

export const postRegisterEventSession = (sessionRegister) => {
	const url = '/api/event-sessions-users'
	return axios.post(url, sessionRegister)
}
/**
 * @param {Number} id
 * @param {Object} deleteRegister
 * @returns {Promise<Object>}
 */

export const deleteRegisterEventSession = (id, deleteRegister) => {
	const url = `/api/event-sessions-users/${id}`
	return axios.delete(url, deleteRegister)
}

/**
 * @param {String} query
 *
 * @returns {Promise<Object>}
 */
export const getSessionSpeakers = (query) => {
	const url = `/api/speakers${query}&expand=speakersList&fields=speakersList`
	return axios.get(url)
}
/**
 * @param {Number} id
 */

export const deleteSessionQuestion = (id) => {
	const url = `/api/question-answers/${id}`
	return axios.delete(url)
}
/**
 * @param {Number} id
 * @param {String} type
 */

export const getSurvey = (id, type = '') => {
	const url = `/api/survey/${id}/${type}`
	return axios.get(url)
}

/**
 * @param {Number} id
 * @param {Object} data
 * @param {String} mode
 */

export const postSurvey = (id, data, mode = 'classic') => {
	const safeMode = mode === 'quiz' ? 'quiz' : 'classic'
	return axios.post(`/api/survey/${id}/submit-${safeMode}`, data)
}

/**
 * @param {Number} id
 * @param {Object} data
 */

export const nextStep = (id, data) => {
	const url = `/api/survey/${id}/next`
	return axios.post(url, data)
}
/**
 * @param {Number} id
 * @param {Object} data
 */
export const backStep = (id, data) => {
	const url = `/api/survey/${id}/back`
	return axios.post(url, data)
}
/**
 * @param {String} query
 *
 * @returns {Promise<Object>}
 */

export const getPartnerFiles = (query) => {
    const url = `/api/partner-uploads${query}`
    return axios.get(url)
}

/**
 * @param {String} query
 *
 * @returns {Promise<Object>}
 */


export const getGiveaways = (query) => {
    const url = `/api/partners/giveaway-list${query}`
    return axios.get(url)
}
